module.exports = __webpack_public_path__ + "static/in-bg-c88809d0d2c453f8763e05d24e083c6b.jpg";